export const CDN_PATH = `https://static.airasia.cn/wmp/miniapp`;
export const CDN_ASSETS_PATH = `${CDN_PATH}/assets`;
